var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoReceipt = function SvgNoReceipt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 168 190",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CADCF0",
    d: "M21 0h129v133H21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2ED",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M125 14H1v144h124z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "M96 40H27a5 5 0 0 0 0 10h69a5 5 0 0 0 0-10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7FA",
    stroke: "#DEE2ED",
    d: "m40.359 175.02-7.859 2.312V45.5h58v131.832l-7.859-2.312-.137-.04-.138.038-8.853 2.459-11.855-3.951-.178-.06-.174.073-9.354 3.939-11.346-2.467-.125-.027z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "M84 65H38v2h46z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4BBDB",
    d: "M84 51H38v10h46z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "M84 70H38v2h46zM84 143H38v2h46zM84 148H38v2h46zM84 153H38v2h46zM84 158H38v2h46zM70 95H38v2h32zM70 100H38v2h32zM70 105H38v2h32zM70 110H38v2h32zM84 95h-9v2h9zM84 100h-9v2h9zM84 105h-9v2h9zM84 110h-9v2h9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.744,
    cy: 92.744,
    r: 31.744,
    fill: "#EE751E",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    stroke: "#414A5F",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M164.373 186.906a7.15 7.15 0 0 1-5.316 1.728 7.141 7.141 0 0 1-4.931-2.633l-53.164-66.021 5.708-4.973 58.196 61.624a7.14 7.14 0 0 1-.493 10.275Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE751E",
    d: "m113.354 120.556-7.419 6.467a2.4 2.4 0 0 1-1.738.586 2.38 2.38 0 0 1-1.642-.816 2.4 2.4 0 0 1 .229-3.386l7.419-6.466a2.39 2.39 0 0 1 1.737-.587 2.4 2.4 0 0 1 1.643.816 2.39 2.39 0 0 1 .344 2.645 2.4 2.4 0 0 1-.573.741M59.59 68.332a33.82 33.82 0 1 0 44.46 50.974 33.82 33.82 0 0 0-44.46-50.974m41.536 47.616a29.393 29.393 0 1 1-38.693-44.257 29.393 29.393 0 0 1 38.693 44.257"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoReceipt);
export default ForwardRef;